export const PLAY_CHAT_SOUND = 'Play Chat Sound';
export const TOGGLE_CHAT_SOUND = 'Toggle Chat Sound'; // params: { isDefault: boolean, isEnabled: boolean; }
export const ADD_CUSTOM_CHAT_SOUND = 'Add Custom Chat Sound';
export const EDIT_CUSTOM_CHAT_SOUND = 'Edit Custom Chat Sound';
export const DELETE_CUSTOM_CHAT_SOUND = 'Delete Custom Chat Sound';
